import React, { useState } from "react";
import { SearchIcon } from "../../Icons";
import Checkbox from "../common/Checkbox";
import SearchDropdown from "../common/SearchDropdown";
import remove from "../../assets/icons/delete-white.svg";
import edit from "../../assets/icons/stylus.svg";
import EditAddData from "./EditAddData";
import vpnKey from "../../assets/icons/vpn_key.svg";
import toast from "react-hot-toast";

export default function TableData({
  rows,
  setRows,
  newData,
  setNewData,
  handleSave,
  addRowForm,
  setAddRowForm,
  selectedRows,
  setSelectedRows,
}) {
  const [activeSearch, setActiveSearch] = useState(null);
  const [searchValues, setSearchValues] = useState({});

  const handleSearchClick = (column) => {
    setActiveSearch(activeSearch === column ? null : column);
  };

  const handleInputChange = (column, value) => {
    setSearchValues((prev) => ({ ...prev, [column]: value }));
  };

  // ✅ handle header checkbox
  const handleSelectAll = () => {
    if (selectedRows.length === rows.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(rows.map((_, idx) => idx));
    }
  };

  // ✅ handle row checkbox
  const handleSelectRow = (idx) => {
    if (selectedRows.includes(idx)) {
      setSelectedRows(selectedRows.filter((i) => i !== idx));
    } else {
      setSelectedRows([...selectedRows, idx]);
    }
  };

  const handleDeleteRow = (index) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
    setSelectedRows((prev) => prev.filter((i) => i !== index));
    toast.success("User Delete successfully!");
  };

  const tableHeaders = ["ID", "권한", "메모"];

  return (
    <div className="p-4 sm:p-5 overflow-hidden  flex-1 flex flex-col ">
      <div className="min-h-[300px] flex-1  overflow-auto">
        {" "}
        <table className="w-full text-center relative whitespace-nowrap ">
          <thead className="sticky top-0 z-[2] text-white text-[14px] whitespace-nowrap font-normal bg-[#232633]">
            <tr className="divide-x divide-[#323649]">
              <th className="px-5 py-[9px]">
                <Checkbox
                  checked={
                    selectedRows.length === rows.length && rows.length > 0
                  }
                  onChange={handleSelectAll}
                  color="white"
                  borderColor="border-white"
                />
              </th>
              <td className="px-5 py-[9px]">No</td>

              {tableHeaders.map((header) => (
                <th key={header} className="px-2.5 py-[9px] relative">
                  <div className="flex items-center gap-4 justify-end">
                    <span className="opacity-0">
                      <SearchIcon color="#E96F0C" />
                    </span>
                    <p className="flex-1 text-center">{header}</p>
                    <button
                      onClick={() => handleSearchClick(header)}
                      aria-label={`Search ${header}`}
                    >
                      <SearchIcon color="#E96F0C" />
                    </button>
                  </div>

                  <SearchDropdown
                    isOpen={activeSearch === header}
                    header={header}
                    value={searchValues[header]}
                    onChange={(value) => handleInputChange(header, value)}
                    onClose={() => setActiveSearch(null)}
                  />
                </th>
              ))}

              <th className="px-5 py-[9px]">작업</th>
            </tr>
          </thead>

          <tbody className="text-[#ABB2CF]">
            {addRowForm && (
              <EditAddData
                data={newData}
                setData={setNewData}
                handleSave={handleSave}
                setAddRowForm={setAddRowForm}
              />
            )}

            {[...rows].map((row, idx) => (
              <tr
                key={idx}
                className={`divide-x divide-[#323649] border-t border-[#323649] ${
                  idx % 2 === 0 ? "bg-[#3D4258]" : "bg-[#464B61]"
                }`}
              >
                <td className="px-5 py-[9px]">
                  <Checkbox
                    checked={selectedRows.includes(idx)}
                    onChange={() => handleSelectRow(idx)}
                  />
                </td>
                <td className="px-5 py-[9px]">{idx + 1}</td>
                <td className="px-5 py-[9px]">{row?.name}</td>
                <td className="px-5 py-[9px]">{row?.authority}</td>
                <td className="px-5 py-[9px]">{row?.memo}</td>

                <td className="px-5 py-[9px]">
                  <div className="flex items-center gap-7 justify-center w-[120px] mx-auto">
                    <button>
                      <img src={vpnKey} alt="vpn" />
                    </button>
                    <button
                      onClick={() => {
                        setNewData(row);
                        setAddRowForm(true);
                      }}
                    >
                      <img src={edit} alt="Edit" />
                    </button>
                    <button onClick={() => handleDeleteRow(idx)}>
                      <img src={remove} alt="Delete" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
